import { useTheme } from '@emotion/react';
import type { FunctionComponent } from 'react';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';

import { ReviewProgressIcon } from './ReviewProgressIcon';
import { ReviewSection } from './ReviewSection';

export const ReviewedBadge: FunctionComponent<{ readonly isActive: boolean }> = ({ isActive }) => {
    const { translate } = useContext(ApplicationContext);
    const theme = useTheme();

    return (
        <ReviewSection
            color={isActive ? theme.colors.white[200] : theme.colors.info[300]}
            data-testid="review-state-reviewed"
        >
            <ReviewProgressIcon colorBase="currentColor" colorFill="currentColor" isActive={isActive} progress={1} />
            <span>{translate('pages.job-architecture-v2.job-profile-status-reviewed')}</span>
        </ReviewSection>
    );
};
